/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".confirm-modal{text-align:center}.confirm-modal .warn-btn .btn{padding:0}.confirm-modal .main-icon{display:block;margin-bottom:2rem;color:red}.confirm-modal .description{margin-bottom:3rem}.confirm-modal .cancel-btn{cursor:pointer;margin-top:2rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/confirm.modal/confirm.modal.component.scss.ngstyle.js.pre-build-optimizer.js